import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CalculationResult, ToolOutput } from '../../../models/calculationModels';

@Component({
    selector: 'app-calculation-output',
    templateUrl: './calculation-output.component.html',
    styleUrls: ['./calculation-output.component.scss'],
    standalone: false
})
export class CalculationOutputComponent {
    @Input() calcOutput: CalculationResult;
    @Input() selectedTool: ToolOutput;
    @Output() showAdvOptPanel: EventEmitter<true> = new EventEmitter();
    @Input() displayIDMSSettings: boolean;
    showAdvancedOutputpanel() {
        this.showAdvOptPanel.emit(true);
    }
}
